import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { Percentual, RegularBenefitVariant } from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuitePercentual(intl: IntlShape) {
  return create(({ value, type }: Percentual) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.Percentual, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })

        test('value', $t(validation.lessThanOrEquals, { value: 100 }), () => {
          enforce(value).lessThanOrEquals(100)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })
    })
  })
}
